export default "__VITE_ASSET__BMiSWUDW__"